import { connect } from 'react-redux';

import { fetchCalendar } from '../../redux/calendar';
import { toggleDetail, toggleLocation, updateSettings } from '../../redux/settings';
import { open as onOpenSettingsModal } from '../../redux/modals/settingsModal';
import {toggleAppointmentModal as onOpenAppointmentCalendarModal} from '../../redux/modals/appintmentCalendarModal';
import SchedulerNavbar from './SchedulerNavbar';

const mapStateToProps = (state) => ({
  ...state.settings,
  ...state.dropdowns,
  date: state.calendar.date,
  loading: state.events.loading,
  mode: state.calendar.mode,
  settings: state.settings,
  showFinancials: state.tokenInfo.scope.indexOf('scheduler:hideFinancials') < 0,
  schedulerView:state.settings.schedulerView,
});

const mapDispatchToProps = {
  onOpenSettingsModal,
  onAppointmentCalenderClick:(show)=> onOpenAppointmentCalendarModal({show:show}),
  onNavigate: fetchCalendar,
  onSettingsChange: updateSettings,
  onToggleDetail: toggleDetail,
  onToggleLocation: toggleLocation,
  onSchedularViewButtonClick:(view)=> updateSettings({ schedulerView: view,entity: 'jobs' }),
  selectJobsTab: () => updateSettings({ entity: 'jobs' }),
};

export default connect(mapStateToProps, mapDispatchToProps)(SchedulerNavbar);
